<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{
        'pii.details.approve.addEmailDialog.title'
          | translate: { recipientType: title }
      }}
    </p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <form (ngSubmit)="addEmail($event)" class="form-group" novalidate>
      <div class="row align-items-center">
        <label for="email" class="label text-end col-3 form-control-label mb-0"
          >{{ 'pii.details.approve.addEmailDialog.email' | translate }}:</label
        >
        <div class="col-8">
          <input
            class="form-control"
            type="email"
            [formControl]="emailControl"
            name="email"
            id="email"
            [placeholder]="
              'pii.details.approve.addEmailDialog.placeholders.email'
                | translate
            "
          />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addEmail($event)">
      {{ 'pii.details.approve.addEmailDialog.buttons.addEmail' | translate }}
    </button>
  </div>
</div>
